interface Policy {
  lastMethod?: 'inviteOpen' | 'microsoft' | 'google' | 'password' | ''
  domainExists?: boolean
  notFound?: boolean
}

export interface UserState {
  authenticated: boolean
  checked: boolean
  pageRedirect: string
  details: null | UserDetails
  runningDebug: boolean
  copy: any
  policy: Policy | null
  userOnboardingSections: OnboardingSection[] | null
}

export const initialState = {
  authenticated: false,
  checked: false,
  pageRedirect: '',
  details: null,
  runningDebug: false,
  copy: null,
  policy: null,
  userOnboardingSections: null,
}

export const user = (
  state: UserState = initialState,
  action: ReduxAction,
): UserState => {
  switch (action.type) {
    case 'AUTHENTICATE':
      return {
        ...state,
        authenticated: true,
        checked: true,
        runningDebug: action?.payload?.runningDebug || state.runningDebug,
      }
    case 'GET_POLICY': {
      // eslint-disable-next-line
      // debugger
      const { policy } = action.payload
      return {
        ...state,
        policy,
      }
    }
    case 'UNAUTHENTICATE':
      return {
        ...state,
        authenticated: false,
        checked: true,
      }
    case 'PAGE_ACCESS_ATTEMPT':
      return {
        ...state,
        pageRedirect: action.payload,
      }
    case 'UPDATE_USER_DETAILS': {
      return {
        ...state,
        details: action.payload,
        runningDebug: action?.payload?.runningDebug || state.runningDebug,
      }
    }
    case 'SET_COPY': {
      return {
        ...state,
        copy: action.payload,
      }
    }
    case 'UPDATE_ONBOARDING_SECTIONS': {
      return {
        ...state,
        userOnboardingSections:
          action.payload.userOnboardingProgress.userOnboardingProgressList,
      }
    }
    default:
      return state
  }
}
